export default __webpack_public_path__ + "audio/02795b1c02b48cfcfa02986ca0cbda01-flyStart.wav";